/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-16 17:53:58
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/Poster/index.tsx
 */
import React from 'react';

import _Poster from 'src/components/Modules/Poster';

import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';

const Poster = (props) => {
  const {
    //staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    handleOnItemReduce,
    staticData,
    disabled,
  } = props || {};

  return (
    <_Poster
      linkModules={dynamicData} //linkModules
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd} //onItemAdd
      onItemChange={handleItemOnChange} //onItemChange
      onItemSort={handleItemOnSort} //onItemSort
      onStaticChange={handleOnStaticsChange} //onStaticChange
      linkSet={linkSet} //linkSet
      specificError={specificError}
      droppableId={droppableId} //droppableId
      handleOnItemReduce={handleOnItemReduce}
      staticData={staticData} //staticData
      disabled={disabled}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(Poster);
